/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {fetchAsyncUserDetails} from '../../../pages/UserPages/accounts/Overview/OverviewSlice/UserDetailsSlice'
import {ENV} from '../../../Utils/_helpers/EnvHelper'

const API_URL = ENV().REACT_APP_API_URL
const initialState = {
  quickSms: {},
}

export const fetchAsyncQuickSms: any = createAsyncThunk(
  'quickSms/fetchAsyncQuickSms',
  async (data, thunkApi) => {
    const response = await axios.post(`${API_URL}gateway`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    response?.data?.success && toast.success(response?.data?.messsage)
    // : toast?.error(response?.data?.messsage)
    thunkApi.dispatch(fetchAsyncUserDetails())
    return response.data
  }
)

const quickSmsSlice = createSlice({
  name: 'quickSMS',
  initialState,
  reducers: {},
  extraReducers: {
    [fetchAsyncQuickSms.pending]: (state) => {},
    [fetchAsyncQuickSms.fulfilled]: (state, {payload}) => {
      {
        payload.status === true ? toast.success(payload.message) : toast.error(payload.message)
      }
      return {...state, quickSms: payload}
    },
    [fetchAsyncQuickSms.rejected]: () => {},
  },
})

export default quickSmsSlice.reducer
